import { render } from "./MapLegend.vue?vue&type=template&id=06de3bd7&scoped=true&ts=true"
import script from "./MapLegend.vue?vue&type=script&lang=ts"
export * from "./MapLegend.vue?vue&type=script&lang=ts"

import "./MapLegend.vue?vue&type=style&index=0&id=06de3bd7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06de3bd7"]])

export default __exports__